export default __webpack_public_path__ + "static/media/osm-topo.90bad225.jpg";